async function getTargetEnvironment() {
  return process.env.CONTENTFUL_ENVIRONMENT_ID || "master"
}

module.exports = getTargetEnvironment
